export const aiDashboardAssets = {
  apps: 'apps',
  marketOverview: 'market_overview',
  timeSpentPenetration: 'time_spent_penetration_time_series',
  timeSpentPenetrationIndex: 'time_spent_penetration_index',
  usageTrends: 'usage_frequency_trend',
  usageTransitions: 'usage_transitions',
  segmentConcentration: 'segment_concentration',
  sectorsStats: 'sectors_stats',
  aiAppTrends: 'top_cohorts_distribution',
  segmentTransitions: 'transitions',
  aiAppImpact: 'ai_app_impact_time_series',
  financeApps: 'finance_apps',
};

export const aiCohortsMap = {
  high_frequency_ai_users: 'High-Frequency AI',
  medium_frequency_ai_users: 'Medium-Frequency AI',
  low_frequency_ai_users: 'Low-Frequency AI',
  churned_app: 'Churned App Usage',
  churned_ai_users: 'Churned AI',
  never_ai_users: 'Never AI',
};

export const aiCohortsColorsMap = {
  high_frequency_ai_users: '#3E8EDE',
  medium_frequency_ai_users: '#15CFD4',
  low_frequency_ai_users: '#F57F51',
  churned_ai_users: '#A26CBD',
  churned_app: '#EA5782',
  never_ai_users: '#748AB2',
};

export const aiCohortsFillColorsMap = {
  high_frequency_ai_users: '#EDF5FD',
  medium_frequency_ai_users: '#E3FCFC',
  low_frequency_ai_users: '#FFF2ED',
  churned_ai_users: '#F6F0F9',
  churned_app: '#FDECF0',
  never_ai_users: '#F5F7FA',
};
